import { gql } from "@apollo/client";

export const UPDATE_BUYER_INFO = gql`
  mutation ($input: BuyerInfoInput!) {
    updateBuyerInfo(input: $input) {
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;

// export const UPDATE_CUSTOMER_INFO = gql`
//   mutation ($input: [UpdateCustomerInfo]!) {
//     updateCustomerInfo(input: $input) {
//       ... on ErrorResponse {
//         ErrorCode
//         ErrorReason
//       }
//     }
//   }
// `;

export const UPDATE_PASSENGERS_INFO = gql`
  mutation (
    $buyerInput: BuyerInfoInput!
    $customerInput: [CustomerInfoInput!]!
  ) {
    updateBuyerInfo(input: $buyerInput) {
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
    updateCustomerInfo(input: $customerInput) {
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;

export const ADD_NEW_JOURNEY_TO_BASKET = gql`
  mutation (
    $basketId: String!
    $outboundJourneyId: String!
    $inboundJourneyId: String!
    $outboundJourneyPriceClass: String
    $inboundJourneyPriceClass: String
    $priceClass: String
    $lang: String
  ) {
    addJourneyToBasket(
      basketId: $basketId
      outboundJourneyId: $outboundJourneyId
      inboundJourneyId: $inboundJourneyId
      outboundJourneyPriceClass: $outboundJourneyPriceClass
      inboundJourneyPriceClass: $inboundJourneyPriceClass
      priceClass: $priceClass
      lang: $lang
    ) {
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
    }
  }
`;

export const CORPORATE_CLIENT_PAY_WITHOUT_CREDENTIALS = gql`
  mutation ($input: CorporateClientPayInput!) {
    corporateClientPay(input: $input) {
      error {
        ErrorCode
        ErrorReason
      }
      success
      objects
    }
  }
`;

export const CREATE_UPDATE_CORPORATE_USER_DATA = gql`
  mutation (
    $firstName: String
    $lastName: String
    $phoneAreaCode: String
    $phoneNumber: String
    $adminEmail: String
    $currency: String
    $language: String
  ) {
    createUpdateCorporateUserData(
      firstName: $firstName
      lastName: $lastName
      phoneAreaCode: $phoneAreaCode
      phoneNumber: $phoneNumber
      adminEmail: $adminEmail
      currency: $currency
      language: $language
    ) {
      ... on ErrorResponse {
        ErrorCode
        ErrorReason
      }
      ... on CorporateAccountValidateModelType {
        ContractId
        ContractReference
        ClientName
        ClientUnitId
        ClientUnitName
        ContractLimit
        AvailableLimit
        IsContractAdmin
        AccountName
        AccountLimit
        AccountDailyLimit
        AccountAvailableLimit
        AccountUserEmail
        FirstName
        LastName
        PhoneAreaCode
        PhoneNumber
        StartDate
        EndDate
        AdminEmail
        Currency
        Language
        ContractStartDate
        ContractEndDate
      }
    }
  }
`;
